import { Card } from 'antd'
import { cardSchema } from '../schemas'
import { renderSchemaArray } from '../utils'
import { withParsedData } from './base'

export const CardRenderer = withParsedData(cardSchema)<{ source?: object }>(({ parsedData, source }) => {
  const { title, body } = parsedData
  const children = renderSchemaArray(body, source)
  return <Card title={title}>{children}</Card>
})
